module.exports = __webpack_public_path__ + "img/6811.b1fc2212.png";